import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { H as o } from "./chunks/index-UjijAVoZ.js";
const n = () => /* @__PURE__ */ e("div", { className: "flex flex-col gap-5 pb-9 tablet:items-center tablet:text-center", children: [
  /* @__PURE__ */ t(o, { level: "4", tagName: "h2", children: "Got questions?" }),
  /* @__PURE__ */ e("p", { className: "max-w-prose text-lg text-neutral-500", children: [
    "If you have questions about the program, feel free to contact us at",
    " ",
    /* @__PURE__ */ t(
      "a",
      {
        className: "underline hover:no-underline",
        href: "mailto:hi@frontendmentor.io",
        children: "hi@frontendmentor.io"
      }
    ),
    ". We look forward to partnering with you!"
  ] })
] });
export {
  n as default
};
